/**
 * Gift box offer actions. Customer-initiated add only.
 * Server price is never taken from the browser to change the Shopify cart.
 */
(function (root) {
  var OFFER_SELECTOR = '[data-caffeine-gift-box]';
  var ADD_SELECTOR = '[data-caffeine-gift-box-add]';
  var QTY_SELECTOR = '[data-caffeine-gift-box-qty]';
  var STATUS_SELECTOR = '[data-caffeine-gift-box-status]';
  var STABLE_OFFER = 'tskies-gift-box';
  var INT_RE = /^[1-9][0-9]*$/;

  function parseQuantity(value, rules) {
    var qty;
    if (typeof value === 'number') {
      if (!Number.isSafeInteger(value) || value < 1) {
        throw quantityError();
      }
      qty = value;
    } else {
      var raw = String(value == null ? '' : value).trim();
      if (!INT_RE.test(raw)) throw quantityError();
      qty = Number(raw);
      if (!Number.isSafeInteger(qty) || qty < 1 || String(qty) !== raw) throw quantityError();
    }
    rules = rules || {};
    if (rules.min != null && qty < rules.min) throw quantityError();
    if (rules.max != null && qty > rules.max) throw quantityError();
    if (rules.increment != null && rules.increment > 1) {
      var min = rules.min != null ? rules.min : 1;
      if ((qty - min) % rules.increment !== 0) throw quantityError();
    }
    return qty;
  }

  function quantityError() {
    var err = new Error('invalid_quantity');
    err.code = 'invalid_quantity';
    return err;
  }

  function readQuantityRule(offer) {
    if (!offer || !offer.getAttribute) return {};
    var min = offer.getAttribute('data-qty-min');
    var max = offer.getAttribute('data-qty-max');
    var increment = offer.getAttribute('data-qty-increment');
    var rules = {};
    if (min) rules.min = Number(min);
    if (max) rules.max = Number(max);
    if (increment) rules.increment = Number(increment);
    return rules;
  }

  function normalizeParent(parent) {
    if (!parent || typeof parent !== 'object') return null;
    var lineKey = String(parent.lineKey || parent.parentLineKey || '').trim();
    var variantId = String(
      parent.variantId == null && parent.parentVariantId == null
        ? ''
        : (parent.variantId == null ? parent.parentVariantId : parent.variantId)
    ).trim();
    if (!lineKey && !variantId) return null;
    return { lineKey: lineKey, variantId: variantId };
  }

  function stableProperties(revision, parent) {
    var props = {
      _caffeine_campaign: STABLE_OFFER,
      _caffeine_revision: String(revision == null ? '' : revision),
      _caffeine_placement: 'cart_drawer',
      _caffeine_offer_type: 'gift_box',
      _caffeine_offer: STABLE_OFFER,
      _caffeine_role: 'addon'
    };
    parent = normalizeParent(parent);
    if (parent && parent.lineKey) props._caffeine_parent_key = parent.lineKey;
    if (parent && parent.variantId) props._caffeine_parent_variant = parent.variantId;
    return props;
  }

  function buildAddBody(variantId, quantity, revision, parent) {
    return {
      id: Number(variantId) || variantId,
      quantity: quantity,
      properties: stableProperties(revision, parent)
    };
  }

  function buildChangeBody(key, nextQuantity) {
    return {
      id: key,
      quantity: nextQuantity
    };
  }

  function resolveAddPlan(cart, variantId, quantity, revision, parent) {
    var qty = parseQuantity(quantity);
    var existing = root.CaffeineCart.findLineByVariantId(cart, variantId);
    if (existing && existing.key) {
      return {
        mode: 'change',
        urlKey: 'cartChange',
        body: buildChangeBody(existing.key, existing.quantity + qty)
      };
    }
    return {
      mode: 'add',
      urlKey: 'cartAdd',
      body: buildAddBody(variantId, qty, revision, parent)
    };
  }

  function toGid(type, id) {
    var numeric = String(id || '').split('/').pop();
    if (!numeric) return '';
    return 'gid://shopify/' + type + '/' + numeric;
  }

  function routes() {
    return (root.theme && root.theme.routes) || {};
  }

  function localizedUrl(key) {
    var value = routes()[key];
    if (!value) throw new Error('missing_route');
    var join = value.indexOf('?') === -1 ? '?' : '&';
    return value + join + 't=' + Date.now();
  }

  function analyticsConfig(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : null);
    if (!doc || typeof doc.getElementById !== 'function') return null;
    var el = doc.getElementById('caffeine-recommendations-config');
    if (!el || !el.dataset) return null;
    var token = el.dataset.ingestToken;
    var url = el.dataset.eventsEndpoint;
    var shop = el.dataset.shop;
    if (!token || !url || !shop) return null;
    return {
      token: token,
      url: url,
      shop: shop,
      currency: el.dataset.currency || '',
      locale: el.dataset.locale || ''
    };
  }

  function hasAffirmativeConsent() {
    var privacy = root.Shopify && root.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
    return privacy.analyticsProcessingAllowed() === true;
  }

  function isMainThemeRole() {
    return !!(root.Shopify && root.Shopify.theme && root.Shopify.theme.role === 'main');
  }

  function isPreviewOffer(el) {
    if (el && el.getAttribute && el.getAttribute('data-preview') === 'true') return true;
    if (el && el.closest) {
      var nested = el.closest(OFFER_SELECTOR);
      if (nested && nested.getAttribute('data-preview') === 'true') return true;
    }
    if (el) return false;
    var doc = typeof document !== 'undefined' ? document : null;
    if (!doc || typeof doc.querySelector !== 'function') return false;
    return !!doc.querySelector(OFFER_SELECTOR + '[data-preview="true"]');
  }

  function canTrack(el) {
    if (root.Shopify && root.Shopify.designMode) return false;
    if (isPreviewOffer(el)) return false;
    if (!isMainThemeRole() || !hasAffirmativeConsent()) return false;
    return !!analyticsConfig();
  }

  function buildAnalyticsPayload(eventType, detail, cfg) {
    cfg = cfg || analyticsConfig();
    detail = detail || {};
    var surface = detail.surface === 'cart_page' ? 'cart_page' : 'cart_drawer';
    var payload = {
      shop: cfg.shop,
      placement: 'cart_drawer',
      eventType: eventType,
      campaignId: STABLE_OFFER,
      campaignRevision: detail.revision == null ? null : Number(detail.revision) || detail.revision,
      offerType: 'gift_box',
      offerId: STABLE_OFFER,
      offerRevision: detail.revision == null ? null : Number(detail.revision) || detail.revision,
      role: 'addon',
      productId: toGid('Product', detail.productId),
      variantId: toGid('ProductVariant', detail.variantId),
      currency: cfg.currency || undefined,
      detail: { surface: surface }
    };
    if (detail.quantity != null) payload.quantity = detail.quantity;
    if (detail.amount != null && Number.isFinite(Number(detail.amount))) {
      var unit = Number(detail.amount);
      payload.amount = detail.quantity != null && Number.isFinite(Number(detail.quantity))
        ? unit * Number(detail.quantity)
        : unit;
    }
    return payload;
  }

  function sendAnalytics(eventType, detail, el) {
    if (!canTrack(el)) return null;
    var cfg = analyticsConfig();
    var payload = buildAnalyticsPayload(eventType, detail, cfg);
    try {
      root.fetch(cfg.url, {
        method: 'POST',
        credentials: 'omit',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'x-caffeine-ingest': cfg.token
        },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (err) {}
    return payload;
  }

  function closestOffer(el) {
    return el && el.closest ? el.closest(OFFER_SELECTOR) : null;
  }

  function liveOffer(previous) {
    if (typeof document === 'undefined' || !document.querySelectorAll) return previous;
    var offers = document.querySelectorAll(OFFER_SELECTOR);
    if (!offers.length) return null;
    if (previous && previous.getAttribute) {
      var variant = previous.getAttribute('data-variant-id');
      for (var i = 0; i < offers.length; i += 1) {
        if (offers[i].getAttribute('data-variant-id') === variant) return offers[i];
      }
    }
    return offers[0];
  }

  function ensurePendingChrome(button) {
    if (!button || !button.querySelector) return;
    var doc = button.ownerDocument || (typeof document !== 'undefined' ? document : null);
    if (!doc || typeof doc.createElement !== 'function') return;
    var label = button.querySelector('[data-caffeine-gift-box-add-label]');
    if (!label) {
      label = doc.createElement('span');
      label.setAttribute('data-caffeine-gift-box-add-label', '');
      while (button.firstChild) label.appendChild(button.firstChild);
      button.appendChild(label);
    }
    if (!button.getAttribute('data-original-label')) {
      button.setAttribute('data-original-label', (label.textContent || '').trim());
    }
    if (!button.querySelector('[data-caffeine-gift-box-spinner]')) {
      var spinner = doc.createElement('span');
      spinner.className = 'caffeine-gift-box__spinner';
      spinner.setAttribute('data-caffeine-gift-box-spinner', '');
      spinner.setAttribute('aria-hidden', 'true');
      button.appendChild(spinner);
    }
  }

  function setOfferPending(offer, pending) {
    if (!offer) return;
    offer.classList.toggle('is-loading', pending);
    if (pending) offer.setAttribute('aria-busy', 'true');
    else offer.removeAttribute('aria-busy');
    var addBtn = offer.querySelector(ADD_SELECTOR);
    if (addBtn) ensurePendingChrome(addBtn);
    offer.querySelectorAll('button, input').forEach(function (control) {
      control.disabled = pending;
      if (control.hasAttribute && control.hasAttribute('data-caffeine-gift-box-add')) {
        if (pending) control.setAttribute('aria-busy', 'true');
        else control.removeAttribute('aria-busy');
      }
    });
    if (addBtn && !pending) {
      var label = addBtn.querySelector('[data-caffeine-gift-box-add-label]');
      var original = addBtn.getAttribute('data-original-label');
      if (label && original) label.textContent = original;
    }
    if (pending) {
      setOfferStatus(offer, strings().adding || 'Adding gift box…', false);
      var pendingStatus = offer.querySelector(STATUS_SELECTOR);
      if (pendingStatus) {
        pendingStatus.classList.add('is-pending');
        pendingStatus.classList.add('visually-hidden');
        pendingStatus.classList.remove('is-error');
      }
    } else {
      var status = offer.querySelector(STATUS_SELECTOR);
      if (status && status.classList.contains('is-pending')) {
        setOfferStatus(offer, '', false);
        status.classList.remove('is-pending');
        status.classList.remove('visually-hidden');
      }
    }
  }

  function setOfferStatus(offer, message, isError) {
    var status = offer && offer.querySelector(STATUS_SELECTOR);
    if (!status) return status;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', !!isError);
    if (isError) {
      status.classList.remove('is-pending');
      status.classList.remove('visually-hidden');
    }
    if (message && isError && typeof status.focus === 'function') {
      status.focus();
    }
    return status;
  }

  function currentCart() {
    var url = localizedUrl('cart');
    return root.fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.text().then(function (text) {
        return root.CaffeineCart.parseJsonResponse(response, text);
      });
    });
  }

  function postCart(urlKey, body) {
    var url = localizedUrl(urlKey);
    return root.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.text().then(function (text) {
        return root.CaffeineCart.parseJsonResponse(response, text);
      });
    });
  }

  function classifyFetchError(err) {
    if (!err) return err;
    if (err.code === 'invalid_json' || err.code === 'network' || err.name === 'TypeError') {
      err.uncertain = true;
      err.code = err.code || 'network';
    }
    return err;
  }

  function performAdd(options) {
    var variantId = options.variantId;
    var requested = parseQuantity(options.quantity, options.quantityRule);
    var revision = options.revision;
    var parent = options.parent || {
      lineKey: options.parentLineKey,
      variantId: options.parentVariantId
    };
    var beforeQty = 0;
    return currentCart()
      .then(function (cart) {
        beforeQty = root.CaffeineCart.quantityForVariant(cart, variantId);
        var plan = resolveAddPlan(cart, variantId, requested, revision, parent);
        return postCart(plan.urlKey, plan.body).then(
          function () {
            return { postError: null };
          },
          function (err) {
            return { postError: classifyFetchError(err) };
          }
        );
      })
      .then(function (result) {
        return currentCart()
          .then(function (after) {
            var afterQty = root.CaffeineCart.quantityForVariant(after, variantId);
            var added = afterQty - beforeQty;
            if (added <= 0) {
              var fail = result.postError || new Error('not_confirmed');
              fail = classifyFetchError(fail);
              fail.code = fail.code || 'not_confirmed';
              fail.cart = after;
              fail.added = 0;
              fail.requested = requested;
              throw fail;
            }
            if (added < requested || result.postError) {
              var partial = new Error('partial_add');
              partial.code = 'partial_add';
              partial.cart = after;
              partial.added = added;
              partial.requested = requested;
              throw partial;
            }
            return {
              cart: after,
              added: added,
              requested: requested,
              beforeQty: beforeQty,
              afterQty: afterQty
            };
          })
          .catch(function (err) {
            if (err && err.cart) throw err;
            err = classifyFetchError(err);
            err.uncertain = true;
            throw err;
          });
      });
  }

  function centsToAmount(cents) {
    var n = Number(cents);
    if (!Number.isFinite(n)) return null;
    return n / 100;
  }

  function readOfferState(offer) {
    var qtyInput = offer.querySelector(QTY_SELECTOR);
    var parent = normalizeParent({
      lineKey: offer.getAttribute('data-parent-line-key'),
      variantId: offer.getAttribute('data-parent-variant-id')
    });
    return {
      variantId: offer.getAttribute('data-variant-id'),
      productId: offer.getAttribute('data-product-id'),
      revision: offer.getAttribute('data-revision'),
      surface: offer.getAttribute('data-surface') || 'cart_drawer',
      quantity: qtyInput ? qtyInput.value : '1',
      quantityRule: readQuantityRule(offer),
      amount: centsToAmount(offer.getAttribute('data-price-cents')),
      parent: parent
    };
  }

  function strings() {
    return (root.theme && root.theme.strings && root.theme.strings.giftBox) || {};
  }

  function errorMessage(err) {
    if (err && err.uncertain) {
      return strings().addUncertain || 'We could not confirm the gift boxes were added. Check your cart before trying again.';
    }
    if (err && err.code === 'partial_add') {
      return strings().partialAdd || 'Only some gift boxes could be added. Check the quantity in your cart.';
    }
    return (
      (err && err.payload && (err.payload.description || err.payload.message)) ||
      strings().addError ||
      'Gift boxes could not be added.'
    );
  }

  function settleCart(token, cart) {
    if (cart && root.CaffeineCart.isFullCart(cart)) {
      root.CaffeineCart.setLastCart(cart);
    }
    if (!root.CaffeineCart.refreshViews || !root.theme || !root.theme.cart) {
      return Promise.resolve(cart);
    }
    return root.CaffeineCart.refreshViews(function () {
      return root.theme.cart.getCartProductMarkup().then(function (payload) {
        return payload && payload.text;
      });
    }, token).then(function () {
      return cart;
    });
  }

  function onAddClick(evt) {
    var button = evt.target.closest(ADD_SELECTOR);
    if (!button) return;
    evt.preventDefault();
    var offer = closestOffer(button);
    if (!offer || offer.classList.contains('is-loading')) return;

    var state;
    try {
      state = readOfferState(offer);
      parseQuantity(state.quantity, state.quantityRule);
    } catch (err) {
      setOfferStatus(offer, strings().invalidQuantity || 'Enter a whole number of 1 or more.', true);
      return;
    }

    setOfferStatus(offer, '', false);
    setOfferPending(offer, true);
    sendAnalytics('add_attempt', {
      surface: state.surface,
      revision: state.revision,
      quantity: parseQuantity(state.quantity, state.quantityRule),
      productId: state.productId,
      variantId: state.variantId,
      amount: state.amount
    }, offer);

    root.CaffeineCart.queueMutation(function (token) {
      return performAdd(state).then(
        function (result) {
          return settleCart(token, result.cart).then(function () {
            return result;
          });
        },
        function (err) {
          if (err && err.cart) {
            return settleCart(token, err.cart).then(function () {
              throw err;
            });
          }
          return settleCart(token).then(function () {
            throw err;
          }, function () {
            throw err;
          });
        }
      );
    })
      .then(function (result) {
        var live = liveOffer(offer);
        if (live) setOfferPending(live, false);
        sendAnalytics('conversion', {
          surface: state.surface,
          revision: state.revision,
          quantity: result.added,
          productId: state.productId,
          variantId: state.variantId,
          amount: state.amount
        }, live || offer);
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { cart: result.cart, source: 'gift_box', settled: true }
          })
        );
      })
      .catch(function (err) {
        var live = liveOffer(offer) || offer;
        if (live) {
          setOfferPending(live, false);
          setOfferStatus(live, errorMessage(err), true);
        }
        sendAnalytics('add_error', {
          surface: state.surface,
          revision: state.revision,
          productId: state.productId,
          variantId: state.variantId,
          quantity: state.quantity
        }, live || offer);
      });
  }

  function offerIsVisible(offer) {
    if (!offer || offer.hidden) return false;
    if (offer.getAttribute('data-available') !== 'true') return false;
    var drawer = offer.closest && offer.closest('#CartDrawer');
    if (drawer && !drawer.classList.contains('drawer--is-open') && !(root.documentElementOpen)) {
      var html = typeof document !== 'undefined' ? document.documentElement : null;
      if (html && !html.classList.contains('js-drawer-open')) return false;
    }
    if (typeof offer.getBoundingClientRect === 'function') {
      var rect = offer.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return false;
    }
    return true;
  }

  var impressed = {};

  function impressionKey(offer) {
    return [
      offer.getAttribute('data-revision'),
      offer.getAttribute('data-variant-id')
    ].join(':');
  }

  function recordImpression(offer) {
    if (!canTrack(offer)) return;
    if (!offerIsVisible(offer)) return;
    var key = impressionKey(offer);
    if (impressed[key]) return;
    impressed[key] = true;
    sendAnalytics('impression', {
      surface: offer.getAttribute('data-surface') || 'cart_drawer',
      revision: offer.getAttribute('data-revision'),
      productId: offer.getAttribute('data-product-id'),
      variantId: offer.getAttribute('data-variant-id'),
      amount: centsToAmount(offer.getAttribute('data-price-cents'))
    }, offer);
  }

  function observeImpressions() {
    if (typeof document === 'undefined') return;
    if (!canTrack()) return;
    document.querySelectorAll(OFFER_SELECTOR).forEach(function (offer) {
      if (impressed[impressionKey(offer)]) return;
      if (!('IntersectionObserver' in root)) {
        recordImpression(offer);
        return;
      }
      if (offer.__caffeineImpressionObserved) return;
      offer.__caffeineImpressionObserved = true;
      var observer = new root.IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) {
            return entry.isIntersecting && entry.intersectionRatio >= 0.5;
          })) {
            recordImpression(offer);
            observer.disconnect();
          }
        },
        { threshold: [0.5] }
      );
      observer.observe(offer);
    });
  }

  function bind() {
    if (typeof document === 'undefined' || bind.bound) return;
    bind.bound = true;
    document.addEventListener('click', onAddClick);
    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter') return;
      if (evt.target && evt.target.matches && evt.target.matches(QTY_SELECTOR)) {
        evt.preventDefault();
        var offer = closestOffer(evt.target);
        var add = offer && offer.querySelector(ADD_SELECTOR);
        if (add) add.click();
      }
    });
    document.addEventListener('caffeine:cart:changed', observeImpressions);
    document.addEventListener('caffeine:cart:open', observeImpressions);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeImpressions);
    } else {
      observeImpressions();
    }
  }

  var api = {
    parseQuantity: parseQuantity,
    stableProperties: stableProperties,
    buildAddBody: buildAddBody,
    buildChangeBody: buildChangeBody,
    resolveAddPlan: resolveAddPlan,
    performAdd: performAdd,
    readOfferState: readOfferState,
    setOfferPending: setOfferPending,
    sendAnalytics: sendAnalytics,
    buildAnalyticsPayload: buildAnalyticsPayload,
    analyticsConfig: analyticsConfig,
    canTrack: canTrack,
    isPreviewOffer: isPreviewOffer,
    hasAffirmativeConsent: hasAffirmativeConsent,
    isMainThemeRole: isMainThemeRole,
    offerIsVisible: offerIsVisible,
    recordImpression: recordImpression,
    toGid: toGid,
    bind: bind
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  root.CaffeineGiftBox = api;
  if (typeof document !== 'undefined') {
    bind();
  }
})(typeof window !== 'undefined' ? window : globalThis);
